import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const conditionalFormattingSidebarEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-conditional-formatting-sidebar" */ './ui/index'),
	),
	getPreloadProps: () => ({}),
});
